import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';

import styles from './tiny-grey-card.module.css';

type Props = {
    icon: React.ReactElement<any>;
    text: string;
    onClick: any;
    isDisabled?: boolean;
    onHover?: any;
    onBlur?: any;
};

export function TinyGreyCard(props: Props) {
    return (
        <ButtonCard onClick={props.onClick} isDisabled={props.isDisabled}>
            <div
                onMouseEnter={(e) => {
                    props.onHover?.(e);
                }}
                onMouseLeave={() => {
                    props.onBlur?.();
                }}
                className={
                    props.isDisabled ? styles['card-content--disabled'] : styles['card-content']
                }
            >
                <div className={styles['card-icon']}>{props.icon}</div>
                <p className={styles['card-text']}>{props.text}</p>
            </div>
        </ButtonCard>
    );
}
